import type { OAuthServiceType } from "@/services/oauth";

export function createOauthServiceMock(): OAuthServiceType {
  return {
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyLCJzdWIyIjoiMTIzNDU2Nzg5MCIsIm5hbWUyIjoiSm9obiBEb2UiLCJpYXQyIjoxNTE2MjM5MDIyLCJzdWIzIjoiMTIzNDU2Nzg5MCIsIm5hbWUzIjoiSm9obiBEb2UiLCJpYXQzIjoxNTE2MjM5MDIyLCJzdWI0IjoiMTIzNDU2Nzg5MCIsIm5hbWU0IjoiSm9obiBEb2UiLCJpYXQ0IjoxNTE2MjM5MDIyLCJzdWI1IjoiMTIzNDU2Nzg5MCIsIm5hbWU1IjoiSm9obiBEb2UiLCJpYXQ1IjoxNTE2MjM5MDIyLCJzdWI2IjoiMTIzNDU2Nzg5MCIsIm5hbWU2IjoiSm9obiBEb2UiLCJpYXQ2IjoxNTE2MjM5MDIyfQ.TvzgLOUuiym38t-r5i8s8-HEgG5cNQdkCzz5RVba8EQ",

    ensureToken() {
      return Promise.resolve(true);
    },
  };
}
